import { api } from './api';

// complaint-controller routes from socialmatrix-api router

export const complaintService = {
  getAll: async () => {
    const { data } = await api.get('/complaints/get-all');
    return data;
  },

  updateComplaint: async (id, payload) => {
    // payload e.g. { status, action, note }
    const { data } = await api.post(`/complaint/${id}/update`, payload);
    return data;
  },

  getComplaintUsers: async (payload) => {
    // backend: complaintController.getComplaintUsers
    const { data } = await api.post('/complaint/users', payload);
    return data;
  },

  getParticipantsChat: async (payload) => {
    // backend: complaintController.getParticipantsChat (admin)
    const { data } = await api.post('/admin/complaints/participants-chat', payload);
    return data;
  },
};

